export default {
  ALL: 'All',
  DOTD_OR_SPECIAL_SALE_EVENT: "Today's Deals/Best Deals",
  REDUCE_THE_PRICE: 'Price Reduction',
  ALREADY_SOLD_OUT: 'Sold Out',
  OUT_OF_STOCK_AT_PRESENT: 'Currently Out of Stock',
  PUT_ON_TOP: 'Pin to top',
  NOT_FAVORITES_YET: 'No favorites yet'
};
